
    /**
    * 删除地址
    **/
      
  import request, {AxiosPromise} from '@utils/request'
  export class IReqid13035 {
  /**
   * (String)
   */
  addressNo?: string | number;
}
  /**
 * YResult :YResult
 */
export class IResid13035 {
  code?: {};
  msg?: {};
  success?: {};
  exceptionMsg?: {};
}
  type Serve<T, G> = (data?: T) => AxiosPromise<G>
  const http: Serve<IReqid13035, IResid13035 > = (data?) =>  request({
        method: 'GET',
        url: '/expressAddress/del',
        params: data
      }) 
  export default http